module.exports = __webpack_public_path__ + "static/media/1.960b113a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80286/1.jpg
// module id = 776
// module chunks = 0